var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "anonymousNewsletterSignup" }, [
    _c(
      "form",
      {
        staticClass: "anonymousSignup",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.subscribe($event)
          }
        }
      },
      [
        _vm.enableExpandedFields
          ? _c("div", { staticClass: "requiredText" }, [
              _vm._v("* " + _vm._s(_vm.settings.requiredFieldText))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "fieldContainer" },
          [
            _c(
              _vm.hintText ? "label" : "span",
              { tag: "component", staticClass: "anonymousEmailWrapper" },
              [
                _vm.hintText
                  ? _c("span", { staticClass: "hintText" }, [
                      _vm._v(_vm._s(_vm.hintText) + " "),
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("*")
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email.value,
                      expression: "email.value"
                    }
                  ],
                  ref: "anonymousEmail",
                  staticClass: "anonymousEmail",
                  class: _vm.email.errorClass,
                  attrs: {
                    type: "email",
                    maxlength: "255",
                    placeholder:
                      _vm.settings.anonymousEmailAddressPlaceholderText,
                    "aria-label": _vm.hintText
                      ? null
                      : _vm.settings.anonymousEmailAddressPlaceholderText
                  },
                  domProps: { value: _vm.email.value },
                  on: {
                    blur: _vm.$_validateEmail,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.email, "value", $event.target.value)
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            _vm.enableExpandedFields
              ? _c("label", { staticClass: "zipCodeWrapper" }, [
                  _c("span", { staticClass: "hintText" }, [
                    _vm._v(_vm._s(_vm.settings.zipCodeLabel) + " "),
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("*")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.zipCode.value,
                        expression: "zipCode.value"
                      }
                    ],
                    ref: "zipCode",
                    staticClass: "zipCode",
                    class: _vm.zipCode.errorClass,
                    attrs: { type: "text", autocomplete: "postal-code" },
                    domProps: { value: _vm.zipCode.value },
                    on: {
                      blur: _vm.$_validateZipCode,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.zipCode, "value", $event.target.value)
                      }
                    }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.enableExpandedFields
              ? _c("label", { staticClass: "languagePreferenceWrapper" }, [
                  _c("span", { staticClass: "hintText" }, [
                    _vm._v(_vm._s(_vm.settings.languagePreferenceLabel) + " "),
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("*")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.languagePreference.value,
                          expression: "languagePreference.value"
                        }
                      ],
                      ref: "languagePreferences",
                      staticClass: "languagePreferenceSelect",
                      class: _vm.languagePreference.errorClass,
                      on: {
                        blur: _vm.$_validateLanguagePreference,
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.languagePreference,
                            "value",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "option",
                        { attrs: { value: "", disabled: "", selected: "" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.settings.languagePreferenceDefaultOptionLabel
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.settings.languagePreferenceOptions, function(
                        language
                      ) {
                        return _c(
                          "option",
                          { domProps: { value: language.value } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(language.label) +
                                "\n                    "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.legalCopy
          ? _c("div", {
              staticClass: "legalText",
              domProps: { innerHTML: _vm._s(_vm.legalCopy) }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "anonymousSubscribeButton",
            style: { backgroundColor: _vm.settings.accentColor },
            attrs: { type: "submit", disabled: _vm.isButtonDisabled }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.buttonText
                    ? _vm.buttonText
                    : _vm.settings.anonymousButtonText
                ) +
                "\n        "
            )
          ]
        )
      ]
    ),
    _vm._v(" "),
    _vm.errorMessages.length > 0
      ? _c(
          "div",
          { staticClass: "anonymousErrors" },
          _vm._l(_vm.errorMessages, function(error) {
            return _c(
              "span",
              { staticClass: "alert alert-error", attrs: { role: "alert" } },
              [_vm._v(_vm._s(error))]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }